import React, { ReactNode } from 'react'

import { Control, Controller, SubmitHandler } from 'react-hook-form'

import { useTranslation } from 'next-i18next'

import { Grid } from '@mui/material'

import { DataTestIds } from 'src/config/dataTestIds'

import { Continue } from '../AuthLayout/components/Continue/Continue'
import { Checkbox, OtpInput } from '../inputs'
import { OTPFields } from '../inputs/OtpInput/OtpInput'

import * as S from './OTPForm.styles'

export const OTPForm = ({
  isValid,
  handleSubmit,
  isLoading,
  onSubmit,
  Resend,
  control,
  deviceSavingPossible,
  values,
}: {
  isValid: boolean
  handleSubmit: (fn: SubmitHandler<OTPFields>) => () => void
  isLoading: boolean
  onSubmit: SubmitHandler<OTPFields>
  control: Control<OTPFields>
  values?: OTPFields
  Resend?: ReactNode | ReactNode
  deviceSavingPossible: boolean
}) => {
  const { t } = useTranslation()

  return (
    <S.Form onSubmit={handleSubmit(onSubmit)} noValidate>
      <Grid spacing={2}>
        <S.Otp item xs={12}>
          <Controller
            name="code"
            control={control}
            render={({ field }) => (
              <OtpInput
                shouldAutoSubmit={!deviceSavingPossible || values.rememberDevice}
                value={values.code}
                handleSubmit={handleSubmit}
                onSubmit={onSubmit}
                isValid={isValid}
                onChange={field.onChange}
              />
            )}
          />
        </S.Otp>
      </Grid>

      <Grid>{Resend}</Grid>

      {deviceSavingPossible && (
        <Controller
          name="rememberDevice"
          control={control}
          render={({ field }) => (
            <Checkbox
              label={t('b2c.mfa.ask_again')}
              name={field.name}
              onChange={field.onChange}
              onBlur={field.onBlur}
              checked={field.value}
              dataTestId={DataTestIds.TrustedDeviceCheckbox}
            />
          )}
        />
      )}

      <Continue type="submit" disabled={!isValid || isLoading}>
        {t('b2c.mfa_form.submit')}
      </Continue>
    </S.Form>
  )
}
